
import { defineComponent } from 'vue'
import { IPackage } from '../../../Workspace'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Message from 'primevue/message'
import WorkspaceSchedulationSchedulationsTable from './WorkspaceSchedulationSchedulationsTable.vue'
import workspaceSchedulationTableDescriptor from './WorkspaceSchedulationTableDescriptor.json'
import { mapState } from 'vuex'

export default defineComponent({
    name: 'workspace-schedulation-table',
    components: { Column, DataTable, Message, WorkspaceSchedulationSchedulationsTable },
    props: { propJobs: { type: Array } },
    emits: ['runSchedulationClick', 'schedulationsSelected', 'viewOldSchedulationsClick'],
    data() {
        return {
            workspaceSchedulationTableDescriptor,
            jobs: [] as IPackage[],
            filters: { global: [filterDefault] } as any,
            expandedRows: [] as any[],
            selectedSchedulations: {} as any
        }
    },
    computed: {
        ...mapState({
            user: 'user'
        }),
        canSeeScheduledExecutions(): any {
            return this.user.functionalities.includes('ViewScheduledWorkspace')
        }
    },
    watch: {
        propJobs() {
            this.loadJobs()
        }
    },
    created() {
        this.loadJobs()
    },
    methods: {
        loadJobs() {
            this.jobs = this.propJobs as IPackage[]
        },
        viewRanSchedulations(job: IPackage) {
            this.$emit('viewOldSchedulationsClick', job)
        },
        setSelectedSchedulations(payload: any) {
            this.selectedSchedulations[payload.index] = payload.schedulations
            this.$emit('schedulationsSelected', this.selectedSchedulations)
        }
    }
})
